
import { addDays, format, parse, isValid } from 'date-fns';
import { PeriodPrediction, PeriodCalculationResult } from './periodCalculatorTypes';

export const calculatePeriodPredictions = (
  lastPeriod: string, 
  cycleLength: string, 
  periodLength: string
): PeriodCalculationResult => {
  // Parse the last period date
  const lastPeriodDate = parse(lastPeriod, 'yyyy-MM-dd', new Date());
  
  if (!isValid(lastPeriodDate)) {
    return { 
      error: 'Please enter a valid last period date',
      title: "Invalid date" 
    };
  }
  
  // Convert to numbers
  const cycleLengthNum = parseInt(cycleLength, 10);
  const periodLengthNum = parseInt(periodLength, 10);
  
  // Validate inputs
  if (cycleLengthNum < 21 || cycleLengthNum > 35) {
    return { 
      error: 'Cycle length should be between 21 and 35 days',
      title: "Invalid cycle length" 
    };
  }
  
  if (periodLengthNum < 2 || periodLengthNum > 10) {
    return { 
      error: 'Period length should be between 2 and 10 days',
      title: "Invalid period length" 
    };
  }
  
  // Calculate predictions for the next 6 months
  const predictions: PeriodPrediction[] = [];
  let nextPeriodDate = lastPeriodDate;
  
  for (let i = 0; i < 6; i++) {
    // Calculate next period start date
    nextPeriodDate = i === 0 ? nextPeriodDate : addDays(nextPeriodDate, cycleLengthNum);
    
    // Calculate period end date
    const periodEndDate = addDays(nextPeriodDate, periodLengthNum - 1);
    
    // Calculate ovulation date (typically 14 days before next period)
    const ovulationDate = addDays(nextPeriodDate, cycleLengthNum - 14);
    
    // Calculate fertile window (typically 5 days before ovulation plus day of ovulation)
    const fertileStartDate = addDays(ovulationDate, -5);
    const fertileEndDate = ovulationDate;
    
    predictions.push({
      periodStart: format(nextPeriodDate, 'MMMM d, yyyy'),
      periodEnd: format(periodEndDate, 'MMMM d, yyyy'),
      ovulationDate: format(ovulationDate, 'MMMM d, yyyy'),
      fertileStart: format(fertileStartDate, 'MMMM d, yyyy'),
      fertileEnd: format(fertileEndDate, 'MMMM d, yyyy')
    });
  }
  
  return predictions;
};

// Generate options for dropdown menus
export const generateCycleLengthOptions = () => {
  return Array.from({ length: 15 }, (_, i) => (21 + i).toString());
};

export const generatePeriodLengthOptions = () => {
  return Array.from({ length: 10 }, (_, i) => (2 + i).toString());
};
